{
  "date_picker": {
    "all_time": "Todo o tempo",
    "confirm": "Confirmar",
    "current_quarter": "Trimestre atual",
    "date_range": "{startDate} - {endDate}",
    "last_n_days": "Últimos {days} dias",
    "last_n_months": "Últimos {months} meses",
    "last_quarter": "Trimestre anterior",
    "last_year": "Ano passado",
    "lifetime": "Todo o período",
    "this_year": "Este ano",
    "today": "Hoje"
  },
  "document_viewer": {
    "sidebar_heading": "Visão geral do conteúdo"
  },
  "dynamic_keys": {
    "saml": {
      "providers": {
        "microsoft_scim": "Microsoft Entra ID",
        "okta_scim": "Okta"
      }
    }
  },
  "error": {
    "title": "Ocorreu um erro."
  },
  "factor_indicator": {
    "average": "Média",
    "bad": "Crítico",
    "excellent": "Excelente",
    "good": "Bom"
  },
  "gauge_chart": {
    "empty": {
      "title": "Nenhum dado disponível",
      "tooltip": "Sua pontuação de resiliência está sendo calculada"
    }
  },
  "locale": {
    "current": "Português",
    "danish": "Dansk",
    "dutch": "Nederlands",
    "english": "English",
    "finnish": "Suomi",
    "french": "Français",
    "german": "Deutsch",
    "norwegian": "Norsk",
    "polish": "Polski",
    "portugese": "Português",
    "spanish": "Español",
    "swedish": "Svenska"
  },
  "saml_provider_button": {
    "continue_with": "Continuar com {provider}"
  },
  "search": {
    "no_options": "Nenhuma opção disponível.",
    "no_results": "Nenhum resultado encontrado.",
    "placeholder": "Pesquisar..."
  },
  "simulations": {
    "expand_preview": {
      "close": "Fechar pré-visualização",
      "open": "Expandir pré-visualização"
    }
  },
  "video_player": {
    "captions": "Legendas",
    "captions_off": "Desativado",
    "normal_speed": "Normal",
    "playback_speed": "Velocidade de reprodução"
  }
}
